import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import PageComponent from '../components/common/PageComponent'
import Attendance from '../components/courses/DetailCoursesBlocks/OnlineClassesBlocks/Attendance';
import Summary from '../components/courses/DetailCoursesBlocks/OnlineClassesBlocks/Summary';
import ClassAttendanceAuditTrail from '../components/courses/DetailCoursesBlocks/OnlineClassesBlocks/ClassAttendanceAuditTrail';

function ClassReport() {

    const { tab, intake, cid } = useParams();
    const [classTitle, setClassTitle] = useState("");

    return (
        <PageComponent
            heading={tab === "summary" ? ["Attendance Summary", classTitle] : ["Class Attendance", classTitle]}
            componentToRender={[
                {
                    condition: tab === "summary",
                    component: <Summary uId={intake} subTab={cid} setClassTitle={setClassTitle} />
                },
                {
                    condition: tab === "attendenceReport",
                    component: <Attendance uId={intake} classTitle={classTitle} setClassTitle={setClassTitle} />
                },
                {
                    condition: tab === "attendanceAuditTrail",
                    component: <ClassAttendanceAuditTrail />
                }
            ]}
            tabs={
                [
                    {
                        tabName: "Summary",
                        tabIcon: "fa-file-alt",
                        url: `/classReport/summary/${intake}/${cid}`,
                        condition: tab === "summary"
                    },
                    {
                        tabName: "Attendance Report",
                        tabIcon: "fa-books",
                        url: `/classReport/attendenceReport/${intake}/${cid}`,
                        condition: tab === "attendenceReport"
                    },
                    {
                        tabName: "Audit Trail",
                        tabIcon: "fa-history",
                        url: `/classReport/attendanceAuditTrail/${intake}/${cid}`,
                        condition: tab === "attendanceAuditTrail"
                    },
                ]
            }
        />
    )
}

export default ClassReport